export class EmailVerificationRequest {
    public loginId: string;
	public emailVerificationCode: String;
    caid: Number;
}
